/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type EnumBillingTransactionExternalIdSource = "instamed" | "paypal" | "salucro" | "%future added value";
export type QuestionCopayBillingCopayIdQueryVariables = {
    id: string;
    billingCopayId: string;
};
export type QuestionCopayBillingCopayIdQueryResponse = {
    readonly billingTransactionOne: {
        readonly _id: string;
        readonly amount: number | null;
        readonly externalId: {
            readonly source: EnumBillingTransactionExternalIdSource | null;
            readonly value: string | null;
        } | null;
        readonly externalLink: string | null;
        readonly createdAt: unknown | null;
        readonly status: string | null;
        readonly billingCopay: {
            readonly name: string | null;
        } | null;
    } | null;
};
export type QuestionCopayBillingCopayIdQuery = {
    readonly response: QuestionCopayBillingCopayIdQueryResponse;
    readonly variables: QuestionCopayBillingCopayIdQueryVariables;
};



/*
query QuestionCopayBillingCopayIdQuery(
  $id: MongoID!
  $billingCopayId: MongoID!
) {
  billingTransactionOne(filter: {patientForm: $id, billingCopay: $billingCopayId}) {
    _id
    amount
    externalId {
      source
      value
    }
    externalLink
    createdAt
    status
    billingCopay {
      name
      id
    }
    id
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "billingCopayId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v2 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "billingCopay",
        "variableName": "billingCopayId"
      },
      {
        "kind": "Variable",
        "name": "patientForm",
        "variableName": "id"
      }
    ],
    "kind": "ObjectValue",
    "name": "filter"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "_id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amount",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "BillingTransactionExternalId",
  "kind": "LinkedField",
  "name": "externalId",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "source",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "value",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "externalLink",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "QuestionCopayBillingCopayIdQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "BillingTransaction",
        "kind": "LinkedField",
        "name": "billingTransactionOne",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "BillingCopay",
            "kind": "LinkedField",
            "name": "billingCopay",
            "plural": false,
            "selections": [
              (v9/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "QuestionCopayBillingCopayIdQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "BillingTransaction",
        "kind": "LinkedField",
        "name": "billingTransactionOne",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "BillingCopay",
            "kind": "LinkedField",
            "name": "billingCopay",
            "plural": false,
            "selections": [
              (v9/*: any*/),
              (v10/*: any*/)
            ],
            "storageKey": null
          },
          (v10/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e6941f04762e333c537062e65ae39fc2",
    "id": null,
    "metadata": {},
    "name": "QuestionCopayBillingCopayIdQuery",
    "operationKind": "query",
    "text": "query QuestionCopayBillingCopayIdQuery(\n  $id: MongoID!\n  $billingCopayId: MongoID!\n) {\n  billingTransactionOne(filter: {patientForm: $id, billingCopay: $billingCopayId}) {\n    _id\n    amount\n    externalId {\n      source\n      value\n    }\n    externalLink\n    createdAt\n    status\n    billingCopay {\n      name\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();
(node as any).hash = 'd10fa89575bfce27c7aa5b22fb35be88';
export default node;
